import styled from 'styled-components';

export const SDiscountCodeAnchor = styled.div`
  text-decoration: underline;
  font-weight: bold;
  font-size: 0.875rem;
  line-height: 1.25rem;
  display: flex;
  margin-bottom: 0.625rem;
  cursor: pointer;
`;

export const SDiscountCodeAnchorMessage = styled.div`
  margin-left: 0.25rem;
`;
